"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./Pagination.css");
var Button_1 = require("../button/Button");
var Icon_1 = require("../icon/Icon");
var react_1 = require("react");
var PaginationItem = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement("li", { className: classnames_1.default('Pagination_item', className) },
        React.createElement(Button_1.Button, __assign({}, props, { className: classnames_1.default('Pagination_link') }), props.children)));
};
exports.Pagination = function (props) {
    var htmlProps = (function (_a) {
        var pageTotal = _a.pageTotal, pageIndex = _a.pageIndex, startPageIndex = _a.startPageIndex, disabled = _a.disabled, disabledPageIndices = _a.disabledPageIndices, nextLabel = _a.nextLabel, prevLabel = _a.prevLabel, hasButtonIcon = _a.hasButtonIcon, onChange = _a.onChange, rest = __rest(_a, ["pageTotal", "pageIndex", "startPageIndex", "disabled", "disabledPageIndices", "nextLabel", "prevLabel", "hasButtonIcon", "onChange"]);
        return rest;
    })(props);
    //--- States ---//
    var max = 3; //max number of pages to display: 3 or 5
    var _a = __read(react_1.useState(props.startPageIndex || 0), 2), curIndex = _a[0], setCurIndex = _a[1];
    var _b = __read(react_1.useState(getPageNumbers(0)), 2), pageNumbers = _b[0], setPageNumbers = _b[1];
    //--- Effects ---//
    react_1.useEffect(function () {
        var pageIndex = props.pageIndex !== undefined ? props.pageIndex : curIndex;
        //if pageIndex is out of range
        if (props.pageTotal <= pageIndex ||
            getNotDisabledIndex(pageIndex, props.disabledPageIndices, props.pageTotal) === -1) {
            //update to 0 or first not disabled index
            pageIndex = getNotDisabledIndex(0, props.disabledPageIndices, props.pageTotal);
            if (props.onChange)
                props.onChange(pageIndex, null);
        }
        updateNotDisabledPage(pageIndex);
    }, [props.pageIndex, props.pageTotal]);
    //--- Utility methods ---//
    function getPageNumbers(index) {
        var length = props.pageTotal >= max ? max : props.pageTotal;
        var nums = [];
        if (index >= props.pageTotal - max + 1) {
            for (var i = props.pageTotal - length; i < props.pageTotal; ++i) {
                nums.push(i);
            }
            // return length === 1 ? [props.pageTotal-1] :
            //   length === 2 ? [props.pageTotal-2,props.pageTotal-1] :
            //   length === 3 ? [props.pageTotal-3,props.pageTotal-2,props.pageTotal-1] :
            //   length === 4 ? [props.pageTotal-4,props.pageTotal-3,props.pageTotal-2,props.pageTotal-1] :
            //   [props.pageTotal-5,props.pageTotal-4,props.pageTotal-3,props.pageTotal-2,props.pageTotal-1]
        }
        else if (index < max - 1) {
            for (var i = 0; i < length; i++) {
                nums.push(i);
            }
            // return length === 1 ? [0] :
            //   length === 2 ? [0,1] :
            //   length === 3 ? [0,1,2] :
            //   length === 4 ? [0,1,2,3] : [0,1,2,3,4]
            //return [0,1,2,3,4]
        }
        else {
            for (var i = 0; i < max; ++i) {
                var middle = (max - 1) / 2;
                nums[i] = index - (middle - i);
            }
            // return [index - 2, index - 1, index, index + 1, index + 2]
        }
        return nums;
    }
    function getButtonArialLabel(pageIndex) {
        var pageLabel = "Page " + (pageIndex + 1);
        var currentLabel = curIndex === pageIndex ? ' (current page)' : '';
        return pageLabel + currentLabel;
    }
    function getPageItemDisabled(pageIndex) {
        var condition1 = props.disabled || undefined;
        var condition2 = (props.disabledPageIndices &&
            props.disabledPageIndices.length > 0 &&
            props.disabledPageIndices.some(function (val) { return val === pageIndex; })) ||
            undefined;
        return condition1 || condition2;
    }
    function getNotDisabledIndex(startIndex, disabledPageIndices, pageTotal, direction) {
        if (disabledPageIndices === void 0) { disabledPageIndices = []; }
        if (direction === void 0) { direction = 'forward'; }
        var endIndex = startIndex;
        var i = 0;
        var pageLength = pageTotal - 1;
        function checkDisabled(index) {
            if (disabledPageIndices.indexOf(index) !== -1) {
                if (i < disabledPageIndices.length) {
                    i++;
                    if (direction === 'backward') {
                        if (index > 0)
                            checkDisabled(index - 1);
                        else
                            endIndex = -1;
                    }
                    else {
                        if (index < pageLength)
                            checkDisabled(index + 1);
                        else
                            endIndex = -1;
                    }
                }
                else {
                    endIndex = -1;
                }
            }
            else {
                endIndex = index;
            }
        }
        if (disabledPageIndices.length > 0)
            checkDisabled(endIndex);
        return endIndex;
    }
    function updateNotDisabledPage(pageIndex) {
        var notDisabledIndex = getNotDisabledIndex(pageIndex, props.disabledPageIndices, props.pageTotal);
        if (notDisabledIndex !== pageIndex) {
            if (props.pageIndex === undefined) {
                setCurIndex(notDisabledIndex);
                setPageNumbers(getPageNumbers(notDisabledIndex));
            }
            if (props.onChange)
                props.onChange(notDisabledIndex, null);
        }
        else {
            setCurIndex(notDisabledIndex);
            setPageNumbers(getPageNumbers(notDisabledIndex));
        }
    }
    //--- Callback methods ---//
    function onItemClick(index, e) {
        if (props.pageIndex === undefined) {
            setCurIndex(index);
            setPageNumbers(getPageNumbers(index));
        }
        if (props.onChange)
            props.onChange(index, e);
    }
    function onPrevClick(e) {
        var index = curIndex > 0 ? curIndex - 1 : 0;
        var notDisabledIndex = getNotDisabledIndex(index, props.disabledPageIndices, props.pageTotal, 'backward');
        if (props.pageIndex === undefined) {
            setCurIndex(notDisabledIndex);
            setPageNumbers(getPageNumbers(notDisabledIndex));
        }
        if (props.onChange)
            props.onChange(notDisabledIndex, e);
    }
    function onNextClick(e) {
        var index = curIndex < props.pageTotal - 1 ? curIndex + 1 : props.pageTotal - 1;
        var notDisabledIndex = getNotDisabledIndex(index, props.disabledPageIndices, props.pageTotal);
        if (props.pageIndex === undefined) {
            setCurIndex(notDisabledIndex);
            setPageNumbers(getPageNumbers(notDisabledIndex));
        }
        if (props.onChange)
            props.onChange(notDisabledIndex, e);
    }
    // when max === 5
    // const showStart =
    //   pageTotal > 5 &&
    //   ((pageTotal === 6 && curIndex >= max - 3) ||
    //     (pageTotal === 7 && curIndex >= max - 2) ||
    //     curIndex >= max - 1)
    // when max === 3
    var showStart = props.pageTotal > 3 && curIndex >= max - 1;
    var showEnd = props.pageTotal > max && curIndex < props.pageTotal - (max - 1);
    return (React.createElement("nav", __assign({ "aria-label": 'Pagination' }, htmlProps, { className: classnames_1.default('Pagination', props.className) }),
        React.createElement(Button_1.Button, { "aria-label": props.prevLabel ? undefined : 'previous', className: 'Pagination_prev', theme: Button_1.ButtonTheme.blueLabel, disabled: props.disabled ||
                curIndex <= 0 ||
                getNotDisabledIndex(curIndex - 1, props.disabledPageIndices, props.pageTotal, 'backward') === -1, onClick: onPrevClick },
            props.hasButtonIcon && (React.createElement(Icon_1.Icon, { className: 'Pagination_prevIcon', type: Icon_1.IconType.longArrowLeft })),
            props.prevLabel && (React.createElement("span", { className: 'Pagination_prevLabel d-none d-md-inline' }, props.prevLabel))),
        React.createElement("ul", { className: 'Pagination_items', "aria-label": 'Pagination items' },
            showStart && (React.createElement(React.Fragment, null,
                React.createElement(PaginationItem, { className: classnames_1.default('Pagination_total', {
                        'Pagination_item-active': curIndex === 0,
                    }), "aria-label": getButtonArialLabel(0), disabled: getPageItemDisabled(0), onClick: function (e) { return onItemClick(0, e); } }, "1"),
                React.createElement("li", { className: 'Pagination_item Pagination_ellipsis', role: 'presentation' }, "\u2026"))),
            pageNumbers.map(function (pageNum) { return (React.createElement(PaginationItem, { key: pageNum, className: classnames_1.default({
                    'Pagination_item-active': curIndex === pageNum,
                }), "aria-label": getButtonArialLabel(pageNum), disabled: getPageItemDisabled(pageNum), onClick: function (e) { return onItemClick(pageNum, e); } }, pageNum + 1)); }),
            showEnd && (React.createElement(React.Fragment, null,
                React.createElement("li", { className: 'Pagination_item Pagination_ellipsis', role: 'presentation' }, "\u2026"),
                React.createElement(PaginationItem, { className: classnames_1.default('Pagination_total', {
                        'Pagination_item-active': curIndex === props.pageTotal - 1,
                    }), "aria-label": getButtonArialLabel(props.pageTotal - 1), disabled: getPageItemDisabled(props.pageTotal - 1), onClick: function (e) { return onItemClick(props.pageTotal - 1, e); } }, props.pageTotal)))),
        React.createElement(Button_1.Button, { "aria-label": props.nextLabel ? undefined : 'next', className: 'Pagination_next', theme: Button_1.ButtonTheme.blueLabel, disabled: props.disabled ||
                curIndex >= props.pageTotal - 1 ||
                getNotDisabledIndex(curIndex + 1, props.disabledPageIndices, props.pageTotal) === -1, onClick: onNextClick },
            props.nextLabel && (React.createElement("span", { className: 'Pagination_nextLabel d-none d-md-inline' }, props.nextLabel)),
            props.hasButtonIcon && (React.createElement(Icon_1.Icon, { className: 'Pagination_nextIcon', type: Icon_1.IconType.longArrowRight })))));
};
exports.Pagination.defaultProps = {
    hasButtonIcon: true,
};
